import { Box, Button, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_RED,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../../_lib/epocus-palette";
import type { ProgramSelection } from "./use-program-selection";

const ActionRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12,
});

const Note = styled(Typography)({
  fontSize: rem(12),
  color: EPOCUS_TEXT_SECONDARY,
});

export const SelectionSaveRow = <T,>({
  selection,
  saveLabel,
  emptyWarning,
}: {
  selection: ProgramSelection<T>;
  saveLabel: string;
  emptyWarning: string;
}) => {
  const { selected, saving, saved, error, save } = selection;
  const empty = selected?.length === 0;

  return (
    <>
      <ActionRow>
        <Button
          variant="contained"
          color="primary"
          disabled={saving || empty}
          onClick={save}
        >
          {saveLabel}
        </Button>
        {empty && <Note>{emptyWarning}</Note>}
        {saved && !empty && (
          <Note>Saved. Everyone's app picks this up on its next sync.</Note>
        )}
      </ActionRow>

      {error && (
        <Typography style={{ fontSize: rem(13), color: EPOCUS_RED }}>
          {error}
        </Typography>
      )}
    </>
  );
};
